export default "__VITE_ASSET__B0ti1V8g__"